var router = require('pjax').Router;
var cart = require('./cart.js');

router.get('cart', cart);
router.get('cart/update', cart);
